import classes from "./index.module.scss";
import { life_1, life_2 } from "../data";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect, useState } from "react";
import Title from "../Title";
import List from "./List";
import Carousel from "./Carousel";

gsap.registerPlugin(ScrollTrigger);

gsap.config({
  force3D: false,
  nullTargetWarn: false,
});

export default function Life() {
  const [open, setOpen] = useState(false);
  const [images, setImages] = useState(undefined);
  const [index, setIndex] = useState(null);

  const handleOpen = (images, index) => {
    document.body.classList.add(classes.hidden);
    setImages(images);
    setIndex(index);
    setOpen(true);
  };
  const handleClose = () => {
    document.body.classList.remove(classes.hidden);
    setOpen(false);
    setImages(undefined);
    setIndex(null);
  };

  const slide = () => {
    const mm = gsap.matchMedia();

    mm.add(
      {
        isMobile:
          "(max-width: 48em) and (prefers-reduced-motion: no-preference)",
        isDesktop:
          "(min-width: 48.01em) and (prefers-reduced-motion: no-preference)",
      },
      (context) => {
        const { isMobile } = context.conditions;
        const tl = gsap
          .timeline({
            scrollTrigger: {
              trigger: `.${classes.wrapper}`,
              scrub: true,
            },
          })
          .to(`.${classes.row}:nth-child(odd) .${classes.list}`, {
            x: isMobile ? "-80vw" : "-35vw",
          })
          .to(
            `.${classes.row}:nth-child(even) .${classes.list}`,
            { x: isMobile ? "80vw" : "35vw" },
            0
          );
        return tl;
      }
    );

    return mm;
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      slide();
    }, 1000);
    return () => {
      clearTimeout(timeout);
      slide().kill();
      handleClose();
    };
  }, []);

  return (
    <section>
      <div className={classes.body}>
        <Title>Our daily life</Title>

        <div className={classes.wrapper}>
          <List handleOpen={handleOpen} images={life_1}></List>
          <List handleOpen={handleOpen} images={life_2}></List>
        </div>
      </div>
      {open ? (
        <div className={classes.backdrop}>
          <Carousel
            images={images}
            currentSlide={index}
            handleClose={handleClose}
          />
        </div>
      ) : null}
    </section>
  );
}
